export function mosaicColorBlender(mosaicCombine) {
  const validColors = mosaicCombine?.filter(
    (item) => item.color && item.color.hex,
  );

  if (validColors?.length === 0) {
    return "#ffffff"; // Білий колір за замовчуванням
  }

  const hexColors = validColors?.map((item) => item.color.hex);

  const rgbComponents = hexColors.map((hex) => ({
    r: parseInt(hex?.slice(1, 3), 16),
    g: parseInt(hex?.slice(3, 5), 16),
    b: parseInt(hex?.slice(5, 7), 16),
  }));

  const avgRGB = {
    r: Math.round(
      rgbComponents?.reduce((sum, color) => sum + color.r, 0) /
        rgbComponents?.length,
    ),
    g: Math.round(
      rgbComponents?.reduce((sum, color) => sum + color.g, 0) /
        rgbComponents?.length,
    ),
    b: Math.round(
      rgbComponents?.reduce((sum, color) => sum + color.b, 0) /
        rgbComponents?.length,
    ),
  };

  const mixedHex = `#${avgRGB?.r.toString(16).padStart(2, "0")}${avgRGB?.g
    .toString(16)
    .padStart(2, "0")}${avgRGB?.b.toString(16).padStart(2, "0")}`;

  return mixedHex;
}
